/* Megamall header v2: All Categories mega menu + sticky header */
if (!customElements.get('mm-categories')) {
  class MmCategories extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('.mm-cat__toggle');
      this.items = Array.from(this.querySelectorAll('[data-cat]'));
      this.panes = Array.from(this.querySelectorAll('[data-pane]'));
      this.promos = Array.from(this.querySelectorAll('[data-promo]'));
      this.hoverable = window.matchMedia('(hover: hover) and (pointer: fine)');

      this.toggle.addEventListener('click', () => (this.hasAttribute('open') ? this.close() : this.open()));

      this.addEventListener('mouseenter', () => {
        if (!this.hoverable.matches) return;
        clearTimeout(this.closeTimer);
        this.openTimer = setTimeout(() => this.open(), 120);
      });
      this.addEventListener('mouseleave', () => {
        if (!this.hoverable.matches) return;
        clearTimeout(this.openTimer);
        this.closeTimer = setTimeout(() => this.close(), 250);
      });

      this.items.forEach((item) => {
        const activate = () => this.setActive(item.dataset.cat);
        item.addEventListener('mouseenter', activate);
        item.addEventListener('focusin', activate);
      });

      this.onKey = (e) => {
        if (e.key === 'Escape' && this.hasAttribute('open')) {
          this.close();
          this.toggle.focus();
        }
      };
      this.onOutside = (e) => { if (!this.contains(e.target)) this.close(); };
      document.addEventListener('keyup', this.onKey);
      document.addEventListener('click', this.onOutside);
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.onKey);
      document.removeEventListener('click', this.onOutside);
    }

    setActive(id) {
      this.items.forEach((i) => i.classList.toggle('is-active', i.dataset.cat === id));
      this.panes.forEach((p) => p.classList.toggle('is-active', p.dataset.pane === id));
      this.promos.forEach((p) => p.classList.toggle('is-active', p.dataset.promo === id));
    }

    open() {
      this.setAttribute('open', '');
      this.toggle.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.removeAttribute('open');
      this.toggle.setAttribute('aria-expanded', 'false');
    }
  }
  customElements.define('mm-categories', MmCategories);
}

if (!customElements.get('sticky-header')) {
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (document.activeElement && document.activeElement.tagName === 'INPUT') return;
      const cats = this.querySelector('mm-categories');
      if (cats && cats.hasAttribute('open')) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => (this.preventReveal = false), 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      const cats = this.querySelector('mm-categories');
      if (cats) cats.close();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }
  customElements.define('sticky-header', StickyHeader);
}
